module.exports = __webpack_public_path__ + "static/img/company-component-cove-1.d0715704.jpg";